module.exports = __webpack_public_path__ + "media/images/pallet-945deb72.png";